import { storageCanBeSet } from './storage-support';
import Cookie from 'js-cookie';
let CookieUtils = {
  get: function (name) {
    var match = window.document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
      return match[2];
    } else {
      return null;
    }
  },
  set: function (name, value, expires, path = '/', secure = null) {
    if (storageCanBeSet('cookie', name)) {
      Cookie.set(name, value, {secure, expires, path })
    }
  },
  setSessionCookie: function (name, value, domain = null, path = '/', secure = true, sameSite = "None") {
    if (storageCanBeSet('cookie', name)) {
      Cookie.set(name, value, {secure, path, sameSite, domain})
    }
  },
  expire: function (name, path = '/') {
    Cookie.remove(name, { path })
  }
};

export default CookieUtils;
